<template lang="html">
     <div class="statistics_2">

          <div class="tabArea">
               <div class="tabTtl">
                   <span class="ttText">播放量统计</span>

                   <div class="timeArea">
                       <span>分项：</span>
                       <el-select v-model="params.type" size="small" @change="typeChange" placeholder="请选择">
                          <el-option
                            v-for="item in typeSelect"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                            :disabled="item.disabled">
                          </el-option>
                        </el-select>
                   </div>

                   <div class="timeArea">
                       <span>分页：</span>
                       <el-select v-model="params.no" size="small" @change="ssPostAct" placeholder="请选择">
                          <el-option
                            v-for="item in pageNumCage"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                            :disabled="item.disabled">
                          </el-option>
                        </el-select>
                   </div>

                   <div class="timeArea">
                       <span>数据库：</span>
                       <el-select class="sp-select" v-model="params.code" size="small" @change="ssPostAct" placeholder="请选择">
                          <el-option
                            v-for="item in labCage"
                            :key="item.code"
                            :label="item.name"
                            :value="item.code">
                          </el-option>
                        </el-select>
                   </div>

              </div>
               <template>
                    <v-chart v-loading="loading" style="height:600px;width:100%;" :options="sortbar"/>
               </template>

          </div>
     </div>
</template>

<script>
import ECharts from 'vue-echarts';
import 'echarts/lib/chart/bar';
import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip';
import { historySum } from '@/api/statistics';
export default {
    components:{
        'v-chart':ECharts
    },
    data(){

         return{

             loading:false,

          // 项选择
             typeSelect:[{
                value:1,
                label:'专辑'
             },{
                value:2,
                label:'单曲'
             }],

             pageNumCage:[],

             params:{
                code:'LCP',
                type:1,
                size:10,
                no:1,
                allPage:0
             },

             labCage:[
                 {name:'中华民族音乐数据库',code:'LCP'},
                 {name:'京剧绝版赏析数据库',code:'JBSX'},
                 {name:'中华戏曲老唱片数据库',code:'XQ'},
                 {name:'中华曲艺老唱片数据库',code:'QY'},
                 {name:'丝绸之路上的民族音乐数据库',code:'SCZL'}
             ],

             sortbar:{
                  tooltip: {
                      trigger: 'axis',
                      axisPointer: {
                          type: 'shadow'
                      }
                  },

                  grid: {
                      left: '180',
                      right: '50',
                      top:'60'
                  },
                  xAxis: {
                      name: '播放量',
                      type: 'value'
                  },
                  yAxis: {
                      name:'单曲',
                      type: 'category',
                      data: []
                  },
                  series: [
                      {
                          name: '',
                          type: 'bar',
                          data: [],
                          axisTick: {show: true},
                          itemStyle: {
                              normal: {
                                  color: '#4cabce',
                              }
                          },
                          label: {
                              normal: {

                                  show: true,
                                  position: 'inside'
                              }
                          },
                          barWidth: 30
                      }
                  ]
             }
         }
    },
    methods:{
         ssPostAct:function(){
             this.loading = true;
             historySum(this.params).then(response => {
                  var unFormate = response.sumTotalPlayList.reverse();
                  this.params.allPage = response.totalPages;
                  var nameArr = [];
                  var numArr = [];
                  for(var i = 0;i < unFormate.length;i++){
                      nameArr.push(unFormate[i].title);
                      numArr.push(unFormate[i].play);
                  }

                  if(response.totalPages > 1){
                       this.pageNumCage = [];
                       for(var i = 0;i < response.totalPages;i++){
                            var temp = {
                                 label:'第' + ( i + 1 ) + '页',
                                 value:i + 1
                            };

                            this.pageNumCage.push(temp);
                       }
                  }

                  this.sortbar.yAxis.data = nameArr;
                  this.sortbar.series[0].data = numArr;

                  this.loading = false;
             }).catch(error => {
                  this.loading = false;
             })
         },

         typeChange:function(){
              this.params.no = 1;
              this.ssPostAct();
         }

    },
    created:function(){
         this.ssPostAct();
    }
}
</script>

<style lang="scss">
      .statistics_2{
           padding: 6px 12px;
           .ttBar{
                padding: 9px 12px 15px;

                border-bottom: 1px solid #e8e8e8;
                span{
                    font-size: 15px;
                    color: #666666;
                }

                .dateSpan{
                   font-size: 14px;
                   font-weight: bold;
                }
           }

           .tabArea{
                padding: 0px 12px;
                .tabTtl{
                     margin-top: 20px;
                    .timeArea{
                        display: inline-block;
                        font-size: 14px;
                        color: #666666;
                        margin-left: 24px;
                        margin-top: 20px;

                        .el-select{
                             width: 90px;
                        }

                        .sp-select{
                             width: 240px;
                        }
                    }
                    .ttText{
                        font-size: 15px;
                        font-weight: bold;
                    }
                }
                table{
                    width: 100%;
                    margin-top: 20px;
                    td{
                        position: relative;
                        border-collapse: collapse;
                        padding: 9px 12px;
                        border: 1px solid #efefef;
                        font-size: 14px;
                        text-align: center;
                    }

                    .tHead td{
                        background: #F8F8F8;
                    }
                }

                .echarts{
                    width: 100%;
                    height: 100%;
                }
           }
      }

</style>



// WEBPACK FOOTER //
// playSort.vue?7b91773a